import { Params } from '@angular/router';

export function extractQueryParams(url: string): { routePath: string; queryParams: Params } {
    const [routePath, queryParamsString] = url?.split('?') ?? [url, ''];
    const queryParams: Params = {};
    if (queryParamsString) {
        queryParamsString.split('&').forEach((param) => {
            const [key, value] = param.split('=');
            queryParams[key] = value;
        });
    }

    return { routePath, queryParams };
}
